import React from "react";
import { rgb } from "d3-color";
const isHiddenRibbon = (mouseOverGroup, sourceIndex, targetIndex) => {
    return mouseOverGroup !== null && mouseOverGroup !== undefined
        ? mouseOverGroup !== sourceIndex && mouseOverGroup !== targetIndex
        : false;
};
const Ribbons = ({ chords, color, disableHover, ribbon, setMouseOverRibbon, mouseOverGroup, mouseOverRibbon, hoverPersist, hoverNode, setHoverPersist, onClick, strokeWidth, blurOnHover, ribbonOpacity, ribbonBlurOpacity }) => (React.createElement("g", { className: "ribbons", fillOpacity: ribbonOpacity }, chords.map((chord, chordIndex) => {
    let hidden = isHiddenRibbon(mouseOverGroup, chord.source.index, chord.target.index) ||
        isHiddenRibbon(mouseOverRibbon, chordIndex, undefined);
    if (hoverNode && hoverNode.fields && Object.keys(hoverNode.fields).length === 2) {
        const fIndex = hoverNode.fields?.[0]?.rank;
        const sIndex = hoverNode.fields?.[1]?.rank;
        hidden = true;
        if ((chord.source.index === fIndex && chord.target.index === sIndex) ||
            (chord.source.index === sIndex && chord.target.index === fIndex)) {
            hidden = false;
        }
    }
    const style = blurOnHover
        ? {
            fillOpacity: `${hidden ? ribbonBlurOpacity : ribbonOpacity}`
        }
        : {
            display: `${hidden ? "none" : "block"}`,
            fillOpacity: ribbonOpacity
        };
    const fColor = color(chord.source.index).opacity === 0.9 || color(chord.source.index).opacity === 0.6
        ? color(chord.source.index)
        : color(chord.target.index);
    return (React.createElement("path", { key: chordIndex, style: style, fill: fColor, stroke: `${rgb(fColor).darker()}`, strokeWidth: strokeWidth, d: `${ribbon({
            source: chord.source,
            target: chord.target
        })}`, onClick: () => {
            setHoverPersist(!hoverPersist);
            onClick?.(chordIndex);
        }, onMouseOver: !disableHover && !hoverPersist ? () => setMouseOverRibbon(chordIndex) : undefined, onMouseOut: !disableHover && !hoverPersist ? () => setMouseOverRibbon(undefined) : undefined }));
})));
export default Ribbons;
